import { makeStyles } from "@material-ui/core/styles";

export const CollectiblesStyles = makeStyles(() => ({
  root: {
    columnGap: 16,
    rowGap: 16,
  },
  button: {
    margin: "20px 0",
  },
  container: {
    display: "flex",
    flexBasis: "267px",
    height: "100%",
  },
}));
